var _rect, _rect2, _circle, _circle2, _circle3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrontend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#4659CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.99976,
    y: 9,
    width: 33.5473,
    height: 23,
    rx: 1.76565,
    fill: "#F8FAFC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.64845,
    cy: 11.6484,
    r: 0.882825,
    fill: "#7997E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.06459,
    cy: 11.6484,
    r: 0.882825,
    fill: "#7997E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4807,
    cy: 11.6484,
    r: 0.882825,
    fill: "#7997E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76562,
    y: 13.9492,
    width: 15.008,
    height: 1.32424,
    rx: 0.662118,
    fill: "#5A74D7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76562,
    y: 16.1562,
    width: 15.008,
    height: 1.32424,
    rx: 0.662118,
    fill: "#5A74D7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76562,
    y: 18.3633,
    width: 15.008,
    height: 1.32424,
    rx: 0.662118,
    fill: "#5A74D7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76562,
    y: 20.5703,
    width: 15.008,
    height: 1.32424,
    rx: 0.662118,
    fill: "#5A74D7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76562,
    y: 22.7773,
    width: 15.008,
    height: 1.32424,
    rx: 0.662118,
    fill: "#5A74D7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.76562,
    y: 27.6328,
    width: 7.80603,
    height: 2.60201,
    rx: 1.30101,
    fill: "#020617"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5393,
    y: 13.4146,
    width: 13.2424,
    height: 13.2424,
    rx: 1.30101,
    fill: "#5A74D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0911 27.9105C30.0354 27.9647 30.0147 28.0449 30.0365 28.1198L30.544 29.8649C30.5659 29.9439 30.6289 29.9999 30.7089 30.0149C30.7903 30.0303 30.8936 29.9765 30.9369 29.9063L31.2722 29.3606C31.3066 29.3046 31.298 29.2324 31.2513 29.1861L30.6225 28.5612C30.5898 28.5298 30.5898 28.4777 30.6225 28.4463C30.6542 28.4148 30.7055 28.4148 30.7382 28.4463L31.3671 29.0722C31.4137 29.1186 31.4863 29.1273 31.5426 29.0931L32.0937 28.7597C32.1592 28.7207 32.1963 28.6534 32.1963 28.5797C32.1963 28.571 32.1963 28.5612 32.1952 28.5525C32.1843 28.4679 32.1264 28.4007 32.0446 28.3758L30.3017 27.8584C30.2275 27.8356 30.1467 27.8562 30.0911 27.9105Z",
    fill: "#130F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontend);
export default __webpack_public_path__ + "static/media/frontend.82eda83a72ab1ff1dbae368975f5d3ba.svg";
export { ForwardRef as ReactComponent };